export const INDIAN_PACKAGE_PATH_KEY = "india";
export const INTERNATIONAL_PACKAGE_PATH_KEY = "world";
export const WEEKEND_GATEWAYS_PACKAGE_PATH_KEY = "weekend-gateways";
export const COUPLE_TOUR_PACKAGE_PATH_KEY = "speciality-tours";
export const LONG_DESCRIPTION_LENGTH = 600;
export const SHORT_DESCRIPTION_LENGTH = 30;
